import { staticColors } from '@common/utils/colors';

const colors = {
  info: '#0066eb',
  error: '#cc4333',
  warn: '#E08906',
  success: '#009621',
  system: '#770BAA'
};

const uniquePathColors = staticColors.slice();

const assignedColors = {};

const assignColors = (url) => {
  if (assignedColors[url]) {
    return assignedColors[url];
  }

  assignedColors[url] = uniquePathColors[Object.keys(assignedColors).length];

  return assignedColors[url];
};

const ORIGIN_REGEX = /[-\/\\^$*+?.()|[\]{}]/g;
const SOURCE_REF_REGEX = /\/[^?]+\?[^:]+:([0-9]+):([0-9]+)/;
const QUERY_PARAMS_REGEX = /\?.*/;

const extractFileInfo = (logString) => {
  const match = logString.match(SOURCE_REF_REGEX);

  if (match && match[0]) {
    const result = match[0].replace(QUERY_PARAMS_REGEX, '');
    return `${result}:${match[1]}:${match[2]}`;
  }

  return null;
};

const cleanLogString = (logString) => {
  const pattern = new RegExp(window.location.origin.replace(ORIGIN_REGEX, '\\$&'), 'g');
  const path = logString.replace(pattern, '');

  return extractFileInfo(path);
};

const getLastPath = (url = '') => {
  const parts = (url || '').split('/').filter(Boolean);
  const lastSegment = parts.pop();
  return lastSegment ? lastSegment.split('?')[0] : null;
};

export const logGroup = function (type, scope, context, data = {}) {
  const stack = new Error().stack;
  const sourceFile = stack?.split('\n')[2];
  const source = cleanLogString(sourceFile);
  const url = data?.url || source;
  const last = getLastPath(url);
  const color = assignColors(url);
  const timing = data?.duration ? ` (${(data.duration / 1000).toFixed(2)}s) ` : ' ';

  console.group(
    `%c ${scope} %c ${context} %c ${last}${timing}`,
    `background-color: #21333D; border-radius: 4px 0 0 4px; padding: 4px 0;`,
    `background-color: ${colors[type]}; padding: 4px 0;`,
    `background-color: #${color}; color: rgba(0,0,0,.4); border-radius: 0 4px 4px 0; padding: 4px 0;`
  );

  if (data) {
    if (typeof data === 'object') {
      console.table({ ...data, logSource: source });
    } else {
      console.log(data);
    }
  }

  console.groupEnd();
};

export const log = function (type, message) {
  console.log(`%c ${message} `, `background-color: ${colors[type]}; border-radius: 4px; padding: 4px 0;`);
};
